export const capitalizeFirstWord = (str) =>
  str
    ?.split(" ")?.[0]
    ?.toLowerCase()
    ?.replace(/^\w/, (c) => c.toUpperCase());
